import React, { FC, SetStateAction, useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Switch,
  useTheme,
  Stack,
  SelectChangeEvent,
  FormControl,
  InputLabel,
  Button,
  Select,
  MenuItem,
  FormHelperText,
  Autocomplete,
  IconButton,
} from "@mui/material";
import { Agent } from "../../../Shared-ui/Types/Agent";
import { NotSelected } from "../../../Constant/Setting";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { MODELS } from "../../../Services/Endpoint";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import Templates from "../../../Constant/Templates";
import Template from "../../../Shared-ui/Types/Template";
import SearchIcon from "@mui/icons-material/Search";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import Chip from "@mui/material/Chip";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import variables from "../../../assets/styles/variables.module.scss";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";

interface MyComponentProps {
  agent: Agent;
  setAgent: React.Dispatch<SetStateAction<Agent>>;
  AgentErr: any;
}

const ModelAndBehavior: FC<MyComponentProps> = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [modelsAndProvider, setModelsAndProvider] = useState();
  const [providers, setProviders] = useState<string[]>([]);
  const [models, setModels] = useState<string[]>([]);
  const [selectedProvider, setSelectedProvider] = useState<string>(NotSelected);
  const [category, setCategories] = useState<any>([]);
  const [activeCategory, setActiveCategory] = useState("All Templates");
  const [filteredTemplates, setFilteredTemplates] =
    useState<Template[]>(Templates);
  const [search, setSearch] = useState("");


  useEffect(() => {
    if (props.agent.model && modelsAndProvider) {
      const provider = props.agent.model.split(":")[0];
      setSelectedProvider(provider);
      if (
        Object.prototype.hasOwnProperty.call(modelsAndProvider, provider) &&
        modelsAndProvider
      ) {
        const models = modelsAndProvider[provider];
        setModels(models);
      }
    }
  }, [modelsAndProvider]);

  useEffect(() => {
    getModels();
  }, []);

  useEffect(() => {
    setFilteredTemplates(Templates);
  }, []);

  useEffect(() => {
    const categoryCounts: { [key: string]: number } = {};

    Templates.forEach((template) => {
      const cat = template.category;
      categoryCounts[cat] = (categoryCounts[cat] || 0) + 1;
    });

    // Convert to array of JSON objects
    const categoryArray = Object.entries(categoryCounts).map(
      ([category, count]) => ({
        category,
        count,
      })
    );
    setCategories([
      { category: "All Templates", count: Templates.length },
      ...categoryArray,
    ]);
  }, []);

  const getModels = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(MODELS).then((res) => res?.data);
      providerOption(data);
      setModelsAndProvider(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const providerOption = (modelData: Record<string, string[]>) => {
    const options = [];
    for (const provider in modelData) {
      options.push(provider);
    }
    setProviders(options);
  };

  const handleChangeProvider = (event: SelectChangeEvent) => {
    const provider = event.target.value;
    setSelectedProvider(provider);
    if (
      Object.prototype.hasOwnProperty.call(modelsAndProvider, provider) &&
      modelsAndProvider
    ) {
      const models = modelsAndProvider[provider];
      setModels(models);
    }
  };

  const handleChnage = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent
  ) => {
    const { name, value } = event.target;
    props.setAgent((preVal) => ({ ...preVal, [name]: value }));
  };

  const handleInstructionTemplateSelect = (template: Template) => {
    props.setAgent({ ...props.agent, instructions: template.content });
  };

  const handleInstructionSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    if (value) {
      const matches = Templates.filter((template) =>
        template.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredTemplates(matches);
    } else {
      setFilteredTemplates(Templates);
    }
  };

  const handleCategoryClick = (category: string) => {
    setActiveCategory(category.split(" ")[0]);
    if (category === "All Templates") {
      setFilteredTemplates(Templates);
    } else {
      const matches = Templates.filter(
        (template) => template.category === category
      );
      setFilteredTemplates(matches);
    }
  };

  const [viewTemplate, setViewTemplate] = useState<Template | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const handleViewClick = (template: Template) => {
    setViewTemplate(template);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setViewTemplate(null);
  };
  const [showTemplatesPanel, setShowTemplatesPanel] = useState(false);

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{ display: { xs: "block", md: "none" }, mt: 1 }}
      >
        Model & Behavior
      </Typography>

      <Box p={theme.spacing(0)}>
        {/* Provider & Model Dropdown */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: theme.spacing(2),
            //mb: theme.spacing(2),
          }}
        >
          <FormControl
            fullWidth
            variant="outlined"
            sx={{ mt: theme.spacing(2) }}
            error={props.AgentErr.provider.value}
          >
            {/*Consistent spacing*/}
            <InputLabel>Provider *</InputLabel>
            <Select
              value={
                selectedProvider ||
                props.agent.model.split(":")[0] ||
                NotSelected
              }
              name="provider"
              onChange={handleChangeProvider}
              error={props.AgentErr.model.value}
              label="Provider & Model"
            >
              <MenuItem value={NotSelected}>Please select provider</MenuItem>
              {/* openAi */}

              {providers.map((provider, index) => (
                <MenuItem value={provider} key={index}>
                  {provider}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{props.AgentErr.provider.error}</FormHelperText>
          </FormControl>

          {/* Provider & Model Dropdown */}
          <FormControl
            fullWidth
            variant="outlined"
            sx={{ mt: theme.spacing(2) }}
            error={props.AgentErr.model.value}
          >
            {/*Consistent spacing*/}
            <InputLabel>Models *</InputLabel>
            <Select
              value={props.agent.model || NotSelected}
              name="model"
              onChange={handleChnage}
              error={props.AgentErr.model.value}
              label="Provider & Model"
            >
              <MenuItem value={NotSelected}>Please select model</MenuItem>
              {/* openAi */}

              {models.map((model, index) => (
                <MenuItem value={`${selectedProvider}:${model}`} key={index}>
                  {model}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* API key */}
          <FormControl
            fullWidth
            variant="outlined"
            sx={{ mt: theme.spacing(2) }}
          // error={props.AgentErr.model.value}
          >
            <InputLabel
              shrink
              htmlFor="API Key"
              sx={{ background: "#fff", px: 0.5 }}
            >
              API Key *
            </InputLabel>
            <TextField
              // value={props.agent.apiKey}
              name="api_key"
              onChange={handleChnage}
              value = {props.agent.api_key}
              // error={props.AgentErr.apiKey.value}
              // helperText={props.AgentErr.apiKey.error}
              fullWidth
              variant="outlined"
              error={props.AgentErr.api_key.value}
            />
          </FormControl>
        </Box>

        <FormHelperText>{props.AgentErr.model.error}</FormHelperText>

        <Stack
          spacing={2}
          sx={{
            marginTop: 2,
          }}
        >
          {/* Instructions */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              alignItems: "stretch",
              minHeight: { md: "300px" },
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: showTemplatesPanel ? "50%" : "100%" },
                mb: { xs: 2, md: 0 },
                transition: "width 0.3s",
                position: "relative",
              }}
            >
              <FormControl fullWidth variant="outlined">
                <InputLabel
                  shrink
                  htmlFor="instructions"
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Instructions *{" "}
                </InputLabel>
                <TextField
                  placeholder="Enter agent Instructions Or Select from Template Gallery"
                  value={props.agent.instructions}
                  name="instructions"
                  onChange={handleChnage}
                  helperText={props.AgentErr.instructions.error}
                  error={props.AgentErr.instructions.value}
                  multiline
                  minRows={15}
                  maxRows={15}
                  fullWidth
                  variant="outlined"
                  inputProps={{ maxLength: 50000 }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "300px",
                      alignItems: "flex-start",
                    },
                    "& .MuiInputBase-input": {
                      height: "100% !important",
                      overflow: "auto",
                    },
                  }}
                />
              </FormControl>
              <Box
                sx={{
                  position: "absolute",
                  top: "-24px",
                  right: "1px",
                  height: "48px",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  borderRadius: "0 0 16px 16px",
                  gap: 1,
                  paddingRight: 2,
                }}
              >
                <Button
                  variant={showTemplatesPanel ? "contained" : "outlined"}
                  disableElevation
                  size="small"
                  onClick={() => setShowTemplatesPanel((prev) => !prev)}
                  startIcon={<CollectionsBookmarkOutlinedIcon />}
                  sx={{
                    textTransform: "capitalize",
                    py: 0,
                    backgroundColor: showTemplatesPanel
                      ? "primary.main"
                      : "#fff", // white bg for outlined
                    borderColor: showTemplatesPanel
                      ? undefined
                      : "rgba(0, 0, 0, 0.23)",
                    "&:hover": {
                      backgroundColor: showTemplatesPanel
                        ? "primary.dark"
                        : "#f5f5f5",
                    },
                  }}
                >
                  {showTemplatesPanel
                    ? "Hide Template Gallery"
                    : "Select from Template Gallery"}
                </Button>
              </Box>
            </Box>

            {showTemplatesPanel && (
              <Box
                sx={{
                  width: { xs: "100%", md: "50%" },
                  transition: "width 0.3s",
                }}
              >
                <Typography variant="subtitle1" gutterBottom>
                  Select Template
                </Typography>
                {/* Search Box */}
                <TextField
                  placeholder="Search Template"
                  value={search}
                  onChange={handleInstructionSearch}
                  size="small"
                  fullWidth
                  // sx={{
                  //   "& .MuiOutlinedInput-root": {
                  //     borderRadius: "8px",
                  //   },
                  // }}
                  InputProps={{
                    startAdornment: (
                      <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                    ),
                  }}
                />

                <Box sx={{ mt: 1.5 }}>
                  {/* Categories */}
                  <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      mb: 1,
                      overflowX: "auto",
                      pb: 1,
                    }}
                  >
                    {category.map((cat: any) => (
                      <Button
                        key={cat.category}
                        onClick={() => handleCategoryClick(cat.category)}
                        disableElevation
                        variant={
                          activeCategory === cat.category
                            ? "contained"
                            : "outlined"
                        }
                        size="small"
                        sx={{
                          flexShrink: 0,
                          borderRadius: "16px",
                          height: "24px",
                          textTransform: "capitalize",
                          backgroundColor:
                            activeCategory === cat.category
                              ? "primary.main"
                              : "transparent",
                          color:
                            activeCategory === cat.category
                              ? "white"
                              : "text.primary",
                          "&:hover": {
                            backgroundColor:
                              activeCategory === cat.category
                                ? "primary.dark"
                                : "rgba(0,0,0,0.04)",
                          },
                          whiteSpace: "nowrap",
                        }}
                      >
                        {cat.category} ({cat.count})
                      </Button>
                    ))}
                  </Stack>

                  {/* Template Cards */}
                  <Box
                    sx={{
                      maxHeight: "158px", // Adjust height as needed
                      overflowY: "auto",
                    }}
                  >
                    <Stack
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                      }}
                    >
                      {filteredTemplates.map((template) => (
                        <Box
                          key={template.id}
                          sx={{
                            padding: "8px 16px",
                            border: "1px solid",
                            borderColor:
                              props.agent.instructions === template.content
                                ? variables.primaryColor
                                : "divider",
                            background:
                              props.agent.instructions === template.content
                                ? "rgba(1, 174, 238, 0.08)"
                                : "transparent",
                            borderRadius: "8px",
                            cursor: "pointer",
                            position: "relative",
                            overflow: "hidden",
                            "&:hover": {
                              backgroundColor:
                                props.agent.instructions === template.content
                                  ? "rgba(1, 174, 238, 0.12)"
                                  : "rgba(0,0,0,0.02)",
                            },
                            "&::before": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "4px",
                              height: "100%",
                              background: variables.primaryColor,
                              borderRadius: "24px 0 0 24px",
                              display: "block",
                              opacity:
                                props.agent.instructions === template.content
                                  ? 1
                                  : 1, // stronger bar for selected
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="subtitle1">
                              {template.name}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Button
                                size="small"
                                variant="contained"
                                disableElevation
                                startIcon={
                                  <ElectricBoltIcon sx={{ fontSize: 16 }} />
                                }
                                sx={{
                                  borderRadius: "4px",
                                  px: "12px",
                                  textTransform: "capitalize",
                                  minHeight: "24px",
                                  height: "24px",
                                }}
                                onClick={() =>
                                  handleInstructionTemplateSelect(template)
                                }
                              >
                                Use
                              </Button>
                              <IconButton
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(template);
                                }}
                                sx={{
                                  backgroundColor: variables.primaryColor,
                                  color: "#fff",
                                  borderRadius: "4px",
                                  minHeight: "24px",
                                  height: "24px",
                                  "&:hover": {
                                    backgroundColor: variables.primaryColor,
                                  },
                                }}
                              >
                                <VisibilityIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </Box>
                          </Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                          >
                            {template.description}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Stack
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {template.tags.map((tag) => (
                                <Chip
                                  key={tag}
                                  label={tag}
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    textTransform: "capitalize",
                                    lineHeight: "18px",
                                  }}
                                />
                              ))}
                            </Stack>
                          </Box>
                        </Box>
                      ))}
                    </Stack>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Stack>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          {viewTemplate && (
            <>
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h6">{viewTemplate.name}</Typography>
                <IconButton onClick={handleCloseDialog} size="small">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {viewTemplate.description}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                  {viewTemplate.tags.map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      sx={{ borderRadius: "4px" }}
                    />
                  ))}
                </Stack>
                <Typography variant="subtitle2" gutterBottom>
                  Instructions:
                </Typography>
                <TextField
                  value={viewTemplate.content}
                  multiline
                  fullWidth
                  minRows={4}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      fontFamily: "monospace",
                    },
                  }}
                />
              </DialogContent>
              <DialogActions
                sx={{ borderTop: "1px solid", borderColor: "divider", p: 2 }}
              >
                <Button
                  onClick={handleCloseDialog}
                  size="small"
                  sx={{
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  disableElevation
                  startIcon={<ElectricBoltIcon />}
                  size="small"
                  onClick={() => {
                    handleInstructionTemplateSelect(viewTemplate);
                    handleCloseDialog();
                  }}
                  sx={{ borderRadius: "4px", textTransform: "none" }}
                >
                  Use Template
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </Box>
    </Box>
  );
};

export default ModelAndBehavior;
